<script lang="ts">
	export let handed: `Right` | `Left`
	export let supports_right_hand: boolean
	export let supports_left_hand: boolean
</script>

<div class=horizontal_radio>
	{#if supports_left_hand}
		<label>
			<input type=radio bind:group={handed} name=handed value=Left>
			Left
		</label>
	{/if}
	{#if supports_right_hand}
		<label>
			<input type=radio bind:group={handed} name=handed value=Right>
			Right
		</label>
	{/if}
</div>

<style>
	label {
		font-size: 16px;
		background-color: var(--better-contrast-background);
		border: 1px solid var(--input-border-gray);
		padding: 0 12px;
		display: flex;
		align-items: center;
		border-radius: 4px;
		font-weight: normal;
		gap: 4px;
		height: 40px;
		font-family: "Protipo Wide", "Helvetica Neue", Helvetica, Arial, sans-serif;
	}

	label:focus-within {
		box-shadow: 0 0 0 3px var(--trex-green);
	}

	.horizontal_radio {
		display: flex;
		flex-direction: row;
		gap: 5px;
	}

	input {
		margin: 0;
		margin-right: 5px;
		transform: scale(1.3);

		outline: none;
		box-shadow: none;
		filter: grayscale(100%);
	}
</style>
